{
  "id": "horus",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Hórus",
    "en": "Horus"
  },
  "icon": "gods/horus",
  "portrait": "gods/horus-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "avenger": 1
  },
  "unlocks": ["avenger", "axe-of-vengeance", "greatest-of-fifty", "spear-of-horus"],
  "powers": ["tornado"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of vengeance. Focus: infantry. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 240 s."
  }
}
